import { buildModuleApi } from "../../../../../_CORE/API/_ApiUtil/_buildModuleApi";

const COMMON_EXCLUDE = [
    "ARCHIVE", "RESTORE", "ARCHIVED", "BULK_CREATE", "BULK_ARCHIVE",
    "BULK_RESTORE", "BULK_REMOVE_REQUEST", "BULK_REMOVE_CONFIRM",
];

const CONTACT_GROUPS = buildModuleApi({
    prefix: "CONTACT_GROUPS",
    uri: "contacts/groups",
    withExtra: false,
    exclude: COMMON_EXCLUDE,
    overrides: {
        LIST: { url: "/contacts/groups" },
        CREATE: { url: "/contacts/groups" },
        UPDATE: { url: "/contacts/groups" },
        REMOVE: { url: "/contacts/groups" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

const CONTACTS = buildModuleApi({
    prefix: "CONTACTS",
    uri: "contacts",
    withExtra: false,
    exclude: COMMON_EXCLUDE,
    overrides: {
        LIST: { url: "/contacts" },
        CREATE: { url: "/contacts" },
        UPDATE: { url: "/contacts" },
        REMOVE: { url: "/contacts" },
        DETAIL: { url: "/contacts/:id" },
    },
    extraActions: {
        ARCHIVE_LIST: { suffix: "/archived/list" },
        ARCHIVE_ONE: { suffix: "/:id/archive" },
        RESTORE_ONE: { suffix: "/:id/restore" },
    },
});

export const CONTACT_GROUP_CONSTANTS = CONTACT_GROUPS.CONSTANTS;
export const CONTACTS_CONSTANTS = CONTACTS.CONSTANTS;
export const CONTACTS_ENDPOINTS = { ...CONTACT_GROUPS.ENDPOINTS, ...CONTACTS.ENDPOINTS };
